// extracted by mini-css-extract-plugin
export default {"base-text":"BaseText_base-text__ob7Oj","checkbox-wrapper":"BaseText_checkbox-wrapper__Zf-2P","checkbox":"BaseText_checkbox__-lM82","base-text-body":"BaseText_base-text-body__XELer"};